import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  fetchAutoLoansBrandNew,
  fetchAutoLoansSecondHand,
} from "network/services/rates";

interface AutoLoansRatesStoreInterface {
  isAllLoading: boolean;
  autoLoansData: any[];
  secondHandAutoLoanData: any[];
  refreshing: boolean;
  error: boolean;
  getAutoLoansData: () => Promise<void>;
  getAutoLoansSecondHand: () => Promise<void>;
  getAllAutoLoansRates: () => Promise<void>;
}

const executeFetchAutoLoansBrandNew = async (): Promise<Array<any>> => {
  try {
    const { data } = await fetchAutoLoansBrandNew();
    return data;
  } catch (e) {
    console.log("error on fetching Auto Loans", e);
    return [];
  }
};

const executeFetchAutoLoansSecondHand = async (): Promise<Array<any>> => {
  try {
    const { data } = await fetchAutoLoansSecondHand();
    return data;
  } catch (e) {
    console.log("error on fetching second Hand auto loans", e);
    return [];
  }
};

let autoLoans: AutoLoansRatesStoreInterface = (set) => ({
  isAllLoading: false,
  autoLoansData: [],
  secondHandAutoLoanData: [],
  refreshing: false,
  error: false,
  getAutoLoansData: async (): Promise<void> => {
    const autoLoansDataResponse = await executeFetchAutoLoansBrandNew();

    if (autoLoansDataResponse?.length === 0) {
      return;
    }
    set({ autoLoansData: autoLoansDataResponse });
  },
  getAutoLoansSecondHand: async (): Promise<void> => {
    const autoLoansSecondHand = await executeFetchAutoLoansSecondHand();

    if (autoLoansSecondHand?.length === 0) {
      return;
    }
    set({ secondHandAutoLoanData: autoLoansSecondHand });
  },
  getAllAutoLoansRates: async (): Promise<void> => {
    set({ isAllLoading: true });
    try {
      const [brand_new, second_hand] = await Promise.all([
        executeFetchAutoLoansBrandNew(),
        executeFetchAutoLoansSecondHand(),
      ]);

      set({
        autoLoansData: brand_new,
        secondHandAutoLoanData: second_hand,
        error: false,
      });
    } catch (e) {
      set({ error: true });
    } finally {
      set({ isAllLoading: false });
    }
  },
});

autoLoans = persist(autoLoans, { name: "auto_loans_rates" });

export const useAutoLoansRates = create(autoLoans);
